import { Link } from 'react-router-dom';
import type { LegalContent } from '@/content/legal/impressum';
import FmbLayout, { FMB_SERIF as SERIF, fmbHomePath } from '@/components/frauMeetsBoerse/FmbLayout';

interface FmbLegalPageProps {
  content: LegalContent;
}

/**
 * Rendert die bestehenden Rechtstexte (src/content/legal/) im
 * Warm-Editorial-Design der Frau-meets-Börse-Landingpage, damit es
 * beim Klick auf die Footer-Links keinen harten Designwechsel gibt.
 */
export default function FmbLegalPage({ content }: FmbLegalPageProps) {
  return (
    <FmbLayout title={`${content.title} – Frau meets Börse`}>
      <main className="mx-auto flex w-full max-w-[800px] flex-col gap-10 px-[clamp(20px,5vw,40px)] pt-[clamp(24px,4vw,48px)] pb-[clamp(72px,11vw,112px)]">
        <Link
          to={fmbHomePath()}
          className="self-start text-[14px] text-[var(--fmb-faint)] no-underline transition-colors hover:text-[var(--fmb-accent)]"
        >
          ← Zurück zur Startseite
        </Link>
        <h1 className={`${SERIF} m-0 text-[clamp(38px,6vw,54px)] leading-[1.08] font-normal text-balance`}>
          {content.title}
        </h1>
        <div className="flex flex-col gap-8 border-t border-[var(--fmb-ink)] pt-8">
          {content.sections.map((section, index) => (
            <section key={index} className="flex flex-col gap-3">
              {section.title !== undefined && (
                <h2 className={`${SERIF} m-0 text-[24px] leading-[1.25] font-normal text-[var(--fmb-accent)]`}>
                  {section.title}
                </h2>
              )}
              <div className="flex flex-col gap-2">
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="m-0 text-[16px] leading-[1.7] text-pretty text-[var(--fmb-muted)]">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
    </FmbLayout>
  );
}
